import Promise from 'bluebird';

import metrics from 'metrics';
import { log } from 'logger';
import createApiClient from 'seek-jobs-api-client';
const api = createApiClient();

const GET_EXPERIMENTS_SUCCESS = 'GET_EXPERIMENTS_SUCCESS';
const GET_EXPERIMENTS_ERROR = 'GET_EXPERIMENTS_ERROR';
export const EXPERIMENT_IMPRESSION = 'EXPERIMENT_IMPRESSION';

const initialState = {
  experiments: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_EXPERIMENTS_SUCCESS: {
      const { experiments } = action.payload;

      return {
        ...state,
        experiments
      };
    }

    default:
      return state;
  }
}

export const trackImpression = (experimentId, { name, variation = {} }) => {
  api.experimentation.trackImpression(experimentId, variation.index);

  return {
    type: EXPERIMENT_IMPRESSION,
    payload: {
      experiment: name,
      variant: variation.name
    }
  };
};

export const getExperiments = visitorId => dispatch => {
  let retries = 2;

  const fetchExperiments = () => {
    return api.experimentation.getExperiments(visitorId)
      .catch(err => {
        const { originalError = {} } = err;

        if (originalError.code === 'ECONNABORTED' && retries-- > 0) {
          metrics.count('experiments-api.timeout-retry', ['timeout-retry:true']);
          log.info({ visitorId }, 'Experiment api timeout retry');
          return fetchExperiments();
        }

        return Promise.reject(err);
      });
  };

  return fetchExperiments()
    .then(response => {
      return dispatch({
        type: GET_EXPERIMENTS_SUCCESS,
        payload: response
      });
    })
    .catch(err => {
      return dispatch({
        type: GET_EXPERIMENTS_ERROR,
        payload: err,
        meta: {
          metrics: {
            name: GET_EXPERIMENTS_ERROR
          }
        }
      });
    });
};

export const trackConversion = experimentId => (_, getState) => {
  const { experiments } = getState().experiments;
  const { variation = {} } = experiments[experimentId];
  const { index } = variation;

  if (index >= 0) {
    return api.experimentation.trackConversion(experimentId, index);
  }
  return null;
};



/** WEBPACK FOOTER **
 ** ./app/store/experiments/experiments.js
 **/